import { AiToneOption, LanguageOption } from "../features/BlockEditor/types.js";

export const userNames = [
  "Lea Thompson",
  "Cyndi Lauper",
  "Tom Cruise",
  "Madonna",
  "Jerry Hall",
  "Joan Collins",
  "Winona Ryder",
  "Christina Applegate",
  "Alyssa Milano",
  "Molly Ringwald",
  "Ally Sheedy",
  "Debbie Harry",
  "Olivia Newton-John",
  "Elton John",
  "Michael J. Fox",
  "Axl Rose",
  "Emilio Estevez",
  "Ralph Macchio",
  "Rob Lowe",
  "Jennifer Grey",
  "Mickey Rourke",
  "John Cusack",
  "Matthew Broderick",
  "Justine Bateman",
  "Lisa Bonet",
];

export const userColors = [
  "#fb7185",
  "#fdba74",
  "#d9f99d",
  "#a7f3d0",
  "#a5f3fc",
  "#a5b4fc",
  "#f0abfc",
];

export const themeColors = [
  "#fb7185",
  "#fdba74",
  "#d9f99d",
  "#a7f3d0",
  "#a5f3fc",
  "#a5b4fc",
];

export const languages: LanguageOption[] = [
  { value: "ar" as LanguageOption["value"], label: "Arabic", name: "arabic" },
  {
    value: "az" as LanguageOption["value"],
    label: "Azerbaijani",
    name: "azerbaijani",
  },
  {
    value: "bs" as LanguageOption["value"],
    label: "Balkan Bosnian",
    name: "balkan_bosnian",
  },
  {
    value: "hr" as LanguageOption["value"],
    label: "Balkan Hrvatski",
    name: "balkan_hrvatski",
  },
  {
    value: "mk" as LanguageOption["value"],
    label: "Balkan Macedonian",
    name: "balkan_macedonian",
  },
  {
    value: "sr" as LanguageOption["value"],
    label: "Balkan Serbian",
    name: "balkan_serbian",
  },
  {
    value: "sq" as LanguageOption["value"],
    label: "Balkan Albanian",
    name: "balkan_albanian",
  },
  {
    value: "bg" as LanguageOption["value"],
    label: "Bulgarian",
    name: "bulgarian",
  },
  { value: "zh" as LanguageOption["value"], label: "Chinese", name: "chinese" },
  { value: "da" as LanguageOption["value"], label: "Danish", name: "danish" },
  { value: "fa-AF" as LanguageOption["value"], label: "Dari", name: "dari" },
  { value: "nl" as LanguageOption["value"], label: "Dutch", name: "dutch" },
  { value: "en" as LanguageOption["value"], label: "English", name: "english" },
  {
    value: "es" as LanguageOption["value"],
    label: "Espanyol",
    name: "espanyol",
  },
  { value: "fi" as LanguageOption["value"], label: "Finnish", name: "finnish" },
  {
    value: "fr" as LanguageOption["value"],
    label: "Français",
    name: "francais",
  },
  {
    value: "ka" as LanguageOption["value"],
    label: "Georgian",
    name: "georgian",
  },
  { value: "el" as LanguageOption["value"], label: "Greek", name: "greek" },
  {
    value: "ha" as LanguageOption["value"],
    label: "Afrika Hausa",
    name: "afrika_hausa",
  },
  { value: "he" as LanguageOption["value"], label: "Hebrew", name: "hebrew" },
  { value: "hi" as LanguageOption["value"], label: "Hindi", name: "hindi" },
  {
    value: "hu" as LanguageOption["value"],
    label: "Hungarian",
    name: "hungarian",
  },
  {
    value: "id" as LanguageOption["value"],
    label: "Bahasa Indonesia",
    name: "bahasa_indonesia",
  },
  { value: "it" as LanguageOption["value"], label: "Italian", name: "italian" },
  {
    value: "ja" as LanguageOption["value"],
    label: "Japanese",
    name: "japanese",
  },
  { value: "kk" as LanguageOption["value"], label: "Kazakh", name: "kazakh" },
  { value: "ko" as LanguageOption["value"], label: "Korean", name: "korean" },
  { value: "kir" as LanguageOption["value"], label: "Kyrgyz", name: "kyrgyz" },
  { value: "ms" as LanguageOption["value"], label: "Malay", name: "malay" },
  { value: "fa" as LanguageOption["value"], label: "Farsi", name: "farsi" },
  { value: "pl" as LanguageOption["value"], label: "Polish", name: "polish" },
  {
    value: "pt" as LanguageOption["value"],
    label: "Portuguese",
    name: "portuguese",
  },
  {
    value: "ps" as LanguageOption["value"],
    label: "Pashto",
    name: "pashto",
  },
  {
    value: "ro" as LanguageOption["value"],
    label: "Romanian",
    name: "romanian",
  },
  { value: "ru" as LanguageOption["value"], label: "Russian", name: "russian" },
  { value: "so" as LanguageOption["value"], label: "Somali", name: "somali" },
  { value: "sv" as LanguageOption["value"], label: "Swedish", name: "swedish" },
  { value: "tat" as LanguageOption["value"], label: "Tatar", name: "tatar" },
  {
    value: "tuk" as LanguageOption["value"],
    label: "Turkmen",
    name: "turkmen",
  },
  { value: "ur" as LanguageOption["value"], label: "Urdu", name: "urdu" },
  { value: "uig" as LanguageOption["value"], label: "Uyghur", name: "uyghur" },
  { value: "uz" as LanguageOption["value"], label: "Uzbek", name: "uzbek" },
  {
    value: "hy" as LanguageOption["value"],
    label: "Armenian",
    name: "armenian",
  },
  {
    value: "sw" as LanguageOption["value"],
    label: "Afrika Swahili",
    name: "afrika_swahili",
  },
  {
    value: "pcm" as LanguageOption["value"],
    label: "Nigerian Pidgin",
    name: "nigerian_pidgin",
  },
  {
    value: "no" as LanguageOption["value"],
    label: "Norwegian",
    name: "norwegian",
  },
];

export const tones: AiToneOption[] = [
  { name: "academic", label: "Academic", value: "academic" },
  { name: "business", label: "Business", value: "business" },
  { name: "casual", label: "Casual", value: "casual" },
  { name: "childfriendly", label: "Childfriendly", value: "childfriendly" },
  { name: "conversational", label: "Conversational", value: "conversational" },
  { name: "emotional", label: "Emotional", value: "emotional" },
  { name: "humorous", label: "Humorous", value: "humorous" },
  { name: "informative", label: "Informative", value: "informative" },
  { name: "inspirational", label: "Inspirational", value: "inspirational" },
  { name: "memeify", label: "Memeify", value: "meme" },
  { name: "narrative", label: "Narrative", value: "narrative" },
  { name: "objective", label: "Objective", value: "objective" },
  { name: "persuasive", label: "Persuasive", value: "persuasive" },
  { name: "poetic", label: "Poetic", value: "poetic" },
];
